var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container top-right"},[_c('transition-group',{attrs:{"name":"toast","tag":"div"}},_vm._l((_vm.toasts),function(toast){return _c('toast-item',{key:toast.id,attrs:{"id":toast.id,"type":toast.type,"message":toast.message,"actions":toast.actions},on:{"remove":_vm.removeToast}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }